<template>
    <vx-card id="header-process" class="pt-5">
        <div class="vx-row steps-header">
            <ul class="progressbar w-full">
                <li v-if="step >= 1" class="active">
                    <div class="header-nav-style-on"> 
                        <img src="../../../../assets/images/icons/personal-id-card-of-a-man_azul.svg" class="right-margin" />
                    </div>
                </li>
                <li v-else >
                    <div class="header-nav-style">
                        <img src="../../../../assets/images/icons/personal-id-card-of-a-man_gris.svg" class="right-margin" />
                    </div>
                </li>
                <li v-if="step >= 2" class="active">
                    <div class="header-nav-style-on"> 
                        <img src="../../../../assets/images/icons/calculator_azul.svg" class="right-margin" />
                    </div>
                </li>
                <li v-else>
                    <div class="header-nav-style">
                        <img src="../../../../assets/images/icons/calculator_gris.svg" class="right-margin" />
                    </div>
                </li>
                <li v-if="step >= 3" class="active">
                    <div class="header-nav-style-on"> 
                        <img src="../../../../assets/images/icons/social-group_azul.svg" class="right-margin" />
                    </div>
                </li>
                <li v-else >
                    <div class="header-nav-style">
                        <img src="../../../../assets/images/icons/social-group_gris.svg" class="right-margin" />
                    </div>
                </li>
                <li v-if="step >= 5" class="active">
                    <div class="header-nav-style-on"> 
                        <img src="../../../../assets/images/icons/verified-list-interface-symbol_azul.svg" class="right-margin" />
                    </div>
                </li>
                <li v-else>
                    <div class="header-nav-style">
                        <img src="../../../../assets/images/icons/verified-list-interface-symbol_gris.svg" class="right-margin" />
                    </div>
                </li>
                <li v-if="step >= 8" class="active">
                    <div class="header-nav-style-on"> 
                        <img src="../../../../assets/images/icons/escritura_azul.svg" class="right-margin" />
                    </div>
                </li>
                <li v-else>
                    <div class="header-nav-style">
                        <img src="../../../../assets/images/icons/escritura_gris.svg" class="right-margin" />
                    </div>
                </li>
            </ul>
        </div>
    </vx-card>
</template>
<script>

/* eslint-disable */
export default {
    name: 'header-process-steps-component',
    props: {
        step: Number,
    },
    data() { 
        return {
            data: null
        }
    },
    created() {
        this.data = [1,2,3,4,5,6,7]
    },
    methods: {
        
    }
}
</script>
<style lang="scss">
//testinh
    #header-process{
        // margin-top:10px;

        .vx-card__body {
            padding: 0rem !important;
        }

        .vx-row {
            margin: 0 !important;
        }

        
        overflow: hidden !important;

    }
    

  .progressbar {
      counter-reset: step;
  }
  .progressbar li {
      list-style-type: none;
      width: 20%;
      float: left;
      font-size: 12px;
      position: relative;
      text-align: center;
      text-transform: uppercase;
      color: #7d7d7d;
  }
  .progressbar li:before {
      width: 100%;
      height: 1px;
      content: "";
      border: 1px solid #7d7d7d;
      display: block;
      position: absolute;
      text-align: center;
      margin: 0 auto 10px auto;
      top: 50%;
      z-index: 100;
  }
  .progressbar li:after {
      width: 100%;
      height: 2px;
      position: absolute;
      background-color: #7d7d7d;
      top: 50%;
      z-index: 100;
  }
  .progressbar li:first-child:after {
      content: none;
  }
  .progressbar li.active {
      color: #086A87;
  }
  .progressbar li.active:before {
      border-color: #086A87;
      background-color: #086A87;

  }
  .progressbar li.active + li:after {
      background-color: #086A87;
  }


@media only screen and (max-width: 550px) {
// @media only screen and (min-width : 320px) 
//   and (max-width : 550px) {
    #header-process{
        .header-nav-style-on img{
            width: 15px;
        }
        .header-nav-style img{
            width: 15px;
        }
    }
}

 @media only screen and (min-width : 551px) 
  and (max-width : 760px) {
      #header-process{
        .header-nav-style-on img{
            width: 20px;
        }
        .header-nav-style img{
            width: 20px;
        }
    }
  }

 @media(min-width: 761px) {

   
 }


</style>